import { withStyles } from "@mui/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment, { Moment } from "moment";
import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";

import Icon, { IconName } from "src/components/Icon/Icon";
import "./SimpleDatePickerField.scss";

export interface ISimpleDatePickerProps<FieldValue, El extends HTMLElement>
  extends FieldProps<FieldValue, FieldRenderProps<FieldValue, El>> {
  label?: string;
  isFormMode?: boolean;
  bare?: boolean;
  showClear?: boolean;
  className?: string;
}

export interface ISimpleDatePickerRenderProps
  extends ISimpleDatePickerProps<Date, HTMLElement>,
    FieldRenderProps<Date, HTMLElement> {}

const StyleDatePicker = withStyles({
  root: {
    background: "transparent",
    "& .MuiPickersCalendarHeader-labelContainer": {
      fontSize: "14px",
    },
    "& .MuiDayCalendar-weekDayLabel": {
      fontSize: "12px",
    },
    "& .MuiPickersDay-root": {
      fontSize: "12px",
    },
  },
})(DatePicker);

export class SimpleDatePicker extends React.Component<ISimpleDatePickerRenderProps> {
  render() {
    const { input, meta, label, disabled, isRequired, showClear, isFormMode, bare } = this.props;

    const displayFormat = "MM-DD-YYYY";
    const inputFormat = "YYYY-MM-DD";

    const value = input.value ? moment(input.value, inputFormat) : null;

    const clearInput = () => {
      input.onChange("");
    };

    if (bare) {
      return (
        <div className="simple-date-picker-v2__wrap">
          <StyleDatePicker
            className={`simple-date-picker-v2 ${isFormMode ? "form-date-picker" : ""}`}
            value={value}
            format={displayFormat}
            onChange={(date: Moment | null) => {
              const dateString = date ? date.format(inputFormat) : null;
              input.onChange(dateString as any);
            }}
            slots={{
              openPickerIcon: () => <Icon name={IconName.Calendar} size="16px" />,
            }}
            slotProps={{
              textField: {
                placeholder: " ",
              },
            }}
          />
        </div>
      );
    }

    /**
     * Open bug about the emptyLabel warning https://github.com/mui-org/material-ui-pickers/issues/1093
     */
    return (
      <div
        className={
          disabled
            ? `simple-date-picker-v2__wrap simple-date-picker-disabled-v2`
            : meta.touched && meta.error
              ? "simple-date-picker-v2__wrap__error dob__wrap"
              : `simple-date-picker-v2__wrap ${this.props.className || ""}`
        }>
        <ul>
          {label && (
            <li>
              <label>{label}</label>
              {isRequired ? <label className="required">&nbsp;*</label> : ""}
            </li>
          )}
          <li>
            <StyleDatePicker
              disabled={disabled}
              className={`simple-date-picker-v2 ${isFormMode ? "form-date-picker" : ""}`}
              value={value}
              format={displayFormat}
              onChange={(date: Moment | null) => {
                const dateString = date ? date.format(inputFormat) : null;
                input.onChange(dateString as any);
              }}
              slots={{
                openPickerIcon: () => <Icon name={IconName.Calendar} size="16px" />,
              }}
              slotProps={{
                field: { clearable: showClear, onClear: clearInput },
                textField: {
                  placeholder: " ",
                },
              }}
            />
          </li>
          {meta.touched && meta.error && <span>{meta.error}</span>}
        </ul>
      </div>
    );
  }
}

export interface ISimpleDatePickerFieldProps
  extends ISimpleDatePickerProps<Date, HTMLElement>,
    FieldProps<Date, FieldRenderProps<Date, HTMLElement>> {}

export default function SimpleDatePickerField(props: ISimpleDatePickerFieldProps) {
  return <Field component={SimpleDatePicker} {...props} />;
}
